export default __webpack_public_path__ + "static/media/Giovanna_900.0c1dc941.webp";